export const VIDEO_COURSE_LINKS = {
    ru: {
        feedBackLink: 'https://forms.yandex.ru/u/679882c7eb61467e2323134d/',
        certificationLink:
            'https://certification.kaspersky.com/partner?code=YkB1MCEyN3kwdHdmKkI=&lang=ru&zipCoded=true',
        pdfLink: 'https://box.kaspersky.com/f/341d500f4fb343c0b2f4/',
        courseSummaryLink: undefined,
    },
    en: {
        feedBackLink: 'https://forms.gle/9YHcCyN8Jyy6rh8u5',
        certificationLink:
            'https://certification.kaspersky.com/partner?code=JDBFMTRXIUFCcGhMbkw=&lang=en&zipCoded=true',
        pdfLink: 'https://box.kaspersky.com/f/7b54e99bc011431686e7/',
        courseSummaryLink: 'https://box.kaspersky.com/f/a39f1d9e44964d8e9ac0/',
    },
    it: {
        feedBackLink:
            'https://docs.google.com/forms/d/e/1FAIpQLSfD7j08w3dO9GJsEhInRi7X8bQUlEBcFBQaQyp69jjeBhss9g/viewform',
        certificationLink:
            'https://certification.kaspersky.com/partner?code=QGotbW9yKlhfM190MFk%3D&lang=it&zipCoded=true',
        pdfLink: 'https://box.kaspersky.com/f/822a19ce42d24df1877f/',
        courseSummaryLink: 'https://box.kaspersky.com/f/7566e45ecbd8415f8024/',
    },
    fr: {
        feedBackLink: 'https://forms.gle/mS8qtYTKaRwrjJcy5',
        certificationLink:
            'https://certification.kaspersky.com/partner?code=Zm9sSTNHLSpzKjdfWEk%3D&lang=fr&zipCoded=true',
        pdfLink: 'https://box.kaspersky.com/f/c4163c6546bb4b939ea2/',
        courseSummaryLink: 'https://box.kaspersky.com/f/c437a17e346747d5b9d3/',
    },
};
